import ABCyaPhaser from "@abcya/abcya_phaser";

export default class LocationData
{
    static CKCLocations()
    {
        var CandleLocation = [ [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], 
                                [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]], [[[]],[[]]] ];
        //var CandleLocation =[];
        var KidCakePair = [];
        var StepOdd = [];
        var StepEven;
        var StepEven1;
        var Increm;

        for(let i = 0;i < 20;i++)
        {
            KidCakePair[i] = 
            {
                cake_xCord:512,cake_yCord:384 + 110,
                kid_xCord:512/3,kid_yCord:384,kid_ContainerOffSet: 0,
                blln_xCord:"50",blln_yCord:"100",cake_imagesrc:"Cake_"+(i+1)+".png",
                kid_imagesrc:"NewAsset/Kids_"+(i+1)+".png",kid_name: "",kid_eyesrc:"NewAsset/Kids_"+(i+1)+"_Eye.png",
                kid_eye1: {x:0,y:0}, kid_eye2: {x:0,y:0},kid_eyeBoth: [0,0,0],
                kid_soundName: ""
            };
        }

        CandleLocation[2][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[3][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[4][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[5][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[6][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[7][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[8][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[9][0] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];

        CandleLocation[1][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[2][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[3][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[4][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[5][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[6][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[7][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[8][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        CandleLocation[9][1] = [[80,240],[80,260],[80,280],[80,300],[80,320],[80,340],[80,360],[80,380],[80,400],[80,420]];
        
        CandleLocation[0][0] = [[469,329],[510,328],[434,329],[546,328],[402,327],[577,327],[371,323],[607,323]];
        CandleLocation[0][1] = [[496,329],[458,328],[536,329],[424,327],[570,328],[601,325],[394,323],[367,316],[627,317]];
        CandleLocation[1][0] = [[467,401],[515,401],[561,402],[422,401],[604,398],[379,399]];
        CandleLocation[1][1] = [[492,390],[534,390],[453,390],[571,390],[413,390]];
        CandleLocation[2][0] = [[475,269,true],[512,270,true],[542,277,true],[445,277,true],[574,289,true],[414,289,true],[604,308,true],[383,311,true],[635,339,true],[353,338,true]];
        CandleLocation[2][1] = [[493,269,true],[534,277,true],[462,275,true],[565,289,true],[428,289,true],[598,303,true],[396,301,true],[630,327,true],[364,327,true]];
        CandleLocation[3][1] = [[485,228],[435,231,true],[530,232,true],[578,241,true],[393,241,true],[615,260,true],[351,266,true]];
        CandleLocation[3][0] = [[463,228,true],[500,228,true],[536,234,true],[428,234,true],[571,245,true],[393,243,true],[605,256,true],[360,255,true]];
        CandleLocation[4][0] = [[460,505],[500,504],[540,504],[419,505],[586,502],[377,503],[627,501],[337,496],[302,484],[664,497]];
        CandleLocation[4][1] = [[492,507],[535,507],[454,506],[576,506],[413,503],[615,502],[369,497],[652,495],[328,490]];
        CandleLocation[5][0] = [[431,219],[559,216],[468,342],[529,342],[383,326],[605,322],[427,460],[580,459],[636,436],[348,435]];
        CandleLocation[5][1] = [[492,223],[537,345],[448,344],[605,321],[381,321],[399,457],[581,459],[639,435],[346,435]];
        CandleLocation[6][0] = [[475,333,true],[508,334,true],[442,344,true],[541,344,true],[410,353,true],[573,353,true],[378,368,true],[605,367,true]];
        CandleLocation[6][1] = [[494,338,true],[462,348,true],[526,348,true],[558,359,true],[428,359,true],[590,369,true],[397,369,true],[622,390,true][367,390,true]];
        CandleLocation[7][0] = [[534,222,true],[453,225],[619,367],[591,384],[557,394],[522,398],[483,399],[447,398]];
        CandleLocation[7][1] = [[495,247],[443,226],[542,225,true],[616,364],[587,387],[555,395],[519,400],[482,399],[444,397]];
        StepEven = 522; StepEven1 = 485; Increm = 35;
        CandleLocation[8][0] = [[StepEven,349,true],[StepEven1,349,true],[StepEven + (Increm * 1),355,true],[StepEven1 - (Increm * 1),355,true],[StepEven + (Increm * 2),367,true],[StepEven1 - (Increm * 2),367,true],[StepEven + (Increm * 3),376,true],[StepEven1 - (Increm * 3),376,true],[StepEven + (Increm * 4),391,true],[StepEven1 - (Increm * 4),391,true]];
        CandleLocation[8][1] = [[506,331,true],[546,343,true],[473,343,true],[583,359,true],[434,356,true],[617,366,true],[399,368,true],[364,391,true],[652,388,true]];
        CandleLocation[9][0] = [[488,341,true],[524,341,true],[554,350,true],[458,350,true],[585,360,true],[428,360,true],[614,373,true],[398,373,true]];
        CandleLocation[9][1] = [[507,337,true],[545,344,true],[469,345,true],[577,353,true],[436,359,true],[608,368,true],[405,368,true]];
        
        CandleLocation[1][1][1][0] = 532.5;
        CandleLocation[1][1][2][0] = 451.5;
        CandleLocation[1][1][3][0] = 573;
        CandleLocation[1][1][4][0] = 411;

        CandleLocation[2][1][1][0] = 531;
        CandleLocation[2][1][2][0] = 459;
        CandleLocation[2][1][3][0] = 567;
        CandleLocation[2][1][4][0] = 423;
        CandleLocation[2][1][5][0] = 603;
        CandleLocation[2][1][6][0] = 387;
        CandleLocation[2][1][7][0] = 639;
        CandleLocation[2][1][8][0] = 351;

        CandleLocation[3][1][1][0] = 526.5;
        CandleLocation[3][1][2][0] = 443.5;
        CandleLocation[3][1][3][0] = 568;
        CandleLocation[3][1][4][0] = 402;
        CandleLocation[3][1][5][0] = 609.5;
        CandleLocation[3][1][6][0] = 360.5;

        
        CandleLocation[4][1][1][0] = 532.5;
        CandleLocation[4][1][2][0] = 451.5;
        CandleLocation[4][1][3][0] = 573;
        CandleLocation[4][1][4][0] = 411;
        CandleLocation[4][1][5][0] = 613.5;
        CandleLocation[4][1][6][0] = 370.5;
        CandleLocation[4][1][7][0] = 654;
        CandleLocation[4][1][8][0] = 330;
        

        CandleLocation[8][1][1][0] = 542.5;
        CandleLocation[8][1][2][0] = 469.5;
        CandleLocation[8][1][3][0] = 579;
        CandleLocation[8][1][4][0] = 433;
        CandleLocation[8][1][5][0] = 615.5;
        CandleLocation[8][1][6][0] = 396.5;
        CandleLocation[8][1][7][0] = 652;
        CandleLocation[8][1][8][0] = 360;

        

        CandleLocation[10][0] = CandleLocation[0][0];
        CandleLocation[10][1] = CandleLocation[0][1]; 
        CandleLocation[11][0] = CandleLocation[1][0];
        CandleLocation[11][1] = CandleLocation[1][1];
        CandleLocation[12][0] = CandleLocation[2][0]; 
        CandleLocation[12][1] = CandleLocation[2][1];
        CandleLocation[13][1] = CandleLocation[3][1];
        CandleLocation[13][0] = CandleLocation[3][0];
        CandleLocation[14][0] = CandleLocation[4][0];
        CandleLocation[14][1] = CandleLocation[4][1];
        CandleLocation[15][0] = CandleLocation[5][0];
        CandleLocation[15][1] = CandleLocation[5][1];
        CandleLocation[16][0] = CandleLocation[6][0];
        CandleLocation[16][1] = CandleLocation[6][1];
        CandleLocation[17][0] = CandleLocation[7][0];
        CandleLocation[17][1] = CandleLocation[7][1];
        CandleLocation[18][0] = CandleLocation[8][0];
        CandleLocation[18][1] = CandleLocation[8][1];
        CandleLocation[19][0] = CandleLocation[9][0];
        CandleLocation[19][1] = CandleLocation[9][1];                
        //[x,y,behind(true or false),rotation number]
        //[[20,20],[20,40],[20,60],[20,80],[20,100],[20,120],[20,140],[20,160],[20,180],[20,200]]
        /*
        CandleLocation[1] = [[555,398,true,0],[507,398],[600,398],[462,398],[642,398],[418,398]];
        CandleLocation[2] = [[364,295],[695,298],[397,274],[437,246],[475,237],[662,275],[629,252],[590,235],[550,230],[510,230]];//dev tools alternate
        CandleLocation[3] = [[623,296],[564,294],[499,296],[429,298],[653,259],[595,241],[532,241],[466,244],[391,267]];
        CandleLocation[4] = [[702,497],[662,501],[620,504],[573,507],[526,507],[482,506],[440,503],[401,498],[365,492],[334,479]];
        CandleLocation[5] = [[603,470],[536,471],[465,470],[377,451],[620,318],[435,314],[686,452],[535,324],[580,185],[486,185]];
        CandleLocation[6] = [[],[],[],[],[],[],[],[],[],[]];//skipping as candles ALL require rotation
        CandleLocation[7] = [[658,365],[630,385],[593,396],[552,399],[510,399],[603,237],[572,244],[533,246],[493,243],[460,230]];
        CandleLocation[8] = [[698,360],[385,361],[523,332],[488,335],[418,345],[452,338],[668,345],[634,337],[597,334],[560,330]];//Depth should be behind cake
        CandleLocation[9] = [[],[],[],[],[],[],[],[],[],[]];//Rotation
        CandleLocation[0] = [[673,325],[641,329],[604,331],[567,332],[532,334],[498,331],[466,329],[432,328],[397,322]];
        */

        /*for (let i in CandleLocation)
        {
            for(let i2 in CandleLocation[i])
            {
                for(let i3 in CandleLocation[i][i2])
                {
                    console.log(CandleLocation[i][i2][i3].length);
                }
            }
        }*/
        //    x   x2   y
        KidCakePair[0].kid_eyeBoth = [39, 27, 175];
        KidCakePair[1].kid_eyeBoth = [41, 27, 168];
        KidCakePair[2].kid_eyeBoth = [54, 23, 126];
        KidCakePair[3].kid_eyeBoth = [31, 49, 143];
        KidCakePair[4].kid_eyeBoth = [34, 26, 177];
        KidCakePair[5].kid_eyeBoth = [63, 9, 188];
        KidCakePair[6].kid_eyeBoth = [73, 5, 176];
        KidCakePair[7].kid_eyeBoth = [64, 3, 201];
        KidCakePair[8].kid_eyeBoth = [30, 39, 228];
        KidCakePair[9].kid_eyeBoth = [58, 10, 153];




        KidCakePair[0].kid_xCord = 137;
        KidCakePair[0].kid_yCord = 514;
        KidCakePair[0].blln_xCord = 272;
        KidCakePair[0].blln_yCord = 277;
        KidCakePair[0].kid_eye1.x = 106;
        KidCakePair[0].kid_eye1.y = 346;
        KidCakePair[0].kid_eye1 = {x:110,y:339};
        KidCakePair[0].kid_eye2 = {x:176,y:339};

        KidCakePair[10].kid_xCord = 137;
        KidCakePair[10].kid_yCord = 514;
        KidCakePair[10].blln_xCord = 272;
        KidCakePair[10].blln_yCord = 277;
        KidCakePair[10].kid_eye1 = {x:110,y:339};
        KidCakePair[10].kid_eye2 = {x:176,y:339};

        KidCakePair[1].cake_yCord = 541;
        KidCakePair[1].kid_xCord = 133;
        KidCakePair[1].kid_yCord = 514;
        KidCakePair[1].blln_xCord = 297; // trouble with images, the hair extends farther than hand
        KidCakePair[1].blln_yCord = 328; //fixed by hidding possible connection under table, so depth of blln needs to be behind table, in front of kid
        KidCakePair[1].kid_eye1 = {x:106,y:346};
        KidCakePair[1].kid_eye2 = {x:174,y:346};

        KidCakePair[11].cake_yCord = 541;
        KidCakePair[11].kid_xCord = 133;
        KidCakePair[11].kid_yCord = 514;
        KidCakePair[11].blln_xCord = 297;
        KidCakePair[11].blln_yCord = 328;
        KidCakePair[11].kid_eye1 = {x:106,y:346};
        KidCakePair[11].kid_eye2 = {x:174,y:346};

        KidCakePair[2].cake_yCord = 535;
        KidCakePair[2].kid_xCord = 139;
        KidCakePair[2].kid_yCord = 440;
        KidCakePair[2].blln_xCord = 290;
        KidCakePair[2].blln_yCord = 296;
        KidCakePair[2].kid_eye1 = {x:116,y:314};
        KidCakePair[2].kid_eye2 = {x:193,y:314};

        KidCakePair[12].cake_yCord = 535;
        KidCakePair[12].kid_xCord = 139;
        KidCakePair[12].kid_yCord = 440;
        KidCakePair[12].blln_xCord = 290;
        KidCakePair[12].blln_yCord = 296;
        KidCakePair[12].kid_eye1 = {x:116,y:314};
        KidCakePair[12].kid_eye2 = {x:193,y:314};

        KidCakePair[3].kid_xCord = 138;
        KidCakePair[3].kid_yCord = 560;
        KidCakePair[3].blln_xCord = 276;
        KidCakePair[3].blln_yCord = 245;
        KidCakePair[3].kid_eye1 = {x:89,y:417};
        KidCakePair[3].kid_eye2 = {x:169,y:417};

        KidCakePair[13].kid_xCord = 138;
        KidCakePair[13].kid_yCord = 560;
        KidCakePair[13].blln_xCord = 276;
        KidCakePair[13].blln_yCord = 245;
        KidCakePair[13].kid_eye1 = {x:89,y:417};
        KidCakePair[13].kid_eye2 = {x:169,y:417};

        KidCakePair[4].cake_yCord = 595;
        KidCakePair[4].cake_xCord = 480;
        KidCakePair[4].kid_xCord = 148;
        KidCakePair[4].kid_yCord = 485;
        KidCakePair[4].blln_xCord = 235;
        KidCakePair[4].blln_yCord = 260;
        KidCakePair[4].kid_eye1 = {x:122,y:308};
        KidCakePair[4].kid_eye2 = {x:182,y:308};

        KidCakePair[14].cake_yCord = 595;
        KidCakePair[14].cake_xCord = 480;
        KidCakePair[14].kid_xCord = 148;
        KidCakePair[14].kid_yCord = 485;
        KidCakePair[14].blln_xCord = 235;
        KidCakePair[14].blln_yCord = 260;
        KidCakePair[14].kid_eye1 = {x:122,y:308};
        KidCakePair[14].kid_eye2 = {x:182,y:308};
        
        KidCakePair[5].cake_yCord = 478;
        KidCakePair[5].kid_yCord = 512;
        KidCakePair[5].kid_xCord = 124;
        KidCakePair[5].blln_xCord = 298;
        KidCakePair[5].blln_yCord = 312;
        KidCakePair[5].kid_eye1 = {x:115,y:324};
        KidCakePair[5].kid_eye2 = {x:187,y:324};

        KidCakePair[15].cake_yCord = 478;
        KidCakePair[15].kid_yCord = 512;
        KidCakePair[15].kid_xCord = 124;
        KidCakePair[15].blln_xCord = 298;
        KidCakePair[15].blln_yCord = 312;
        KidCakePair[15].kid_eye1 = {x:115,y:324};
        KidCakePair[15].kid_eye2 = {x:187,y:324};

        KidCakePair[6].cake_xCord = 534;
        KidCakePair[6].cake_yCord = 658;
        KidCakePair[6].kid_xCord = 99;
        KidCakePair[6].kid_yCord = 484;
        KidCakePair[6].blln_xCord = 314;
        KidCakePair[6].blln_yCord = 320;
        KidCakePair[6].kid_eye1 = {x:94,y:308};
        KidCakePair[6].kid_eye2 = {x:172,y:309};

        KidCakePair[16].cake_xCord = 534;
        KidCakePair[16].cake_yCord = 658;
        KidCakePair[16].kid_xCord = 99;
        KidCakePair[16].kid_yCord = 484;
        KidCakePair[16].blln_xCord = 314;
        KidCakePair[16].blln_yCord = 320;
        KidCakePair[16].kid_eye1 = {x:94,y:308};
        KidCakePair[16].kid_eye2 = {x:172,y:309};

        KidCakePair[7].cake_xCord = 487;
        KidCakePair[7].cake_yCord = 507;
        KidCakePair[7].kid_xCord = 137;
        KidCakePair[7].kid_yCord = 505;
        KidCakePair[7].blln_xCord = 319;
        KidCakePair[7].blln_yCord = 320;
        KidCakePair[7].kid_eye1 = {x:134,y:304};
        KidCakePair[7].kid_eye2 = {x:201,y:304};
        
        KidCakePair[17].cake_xCord = 487;
        KidCakePair[17].cake_yCord = 507;
        KidCakePair[17].kid_xCord = 137;
        KidCakePair[17].kid_yCord = 505;
        KidCakePair[17].blln_xCord = 319;
        KidCakePair[17].blln_yCord = 320;
        KidCakePair[17].kid_eye1 = {x:134,y:304};
        KidCakePair[17].kid_eye2 = {x:201,y:304};

        KidCakePair[8].cake_xCord = 538;
        KidCakePair[8].cake_yCord = 546;
        KidCakePair[8].kid_xCord = 129;
        KidCakePair[8].kid_yCord = 529;
        KidCakePair[8].blln_xCord = 288;
        KidCakePair[8].blln_yCord = 325;
        KidCakePair[8].kid_eye1 = {x:90,y:301};
        KidCakePair[8].kid_eye2 = {x:159,y:301};

        KidCakePair[18].cake_xCord = 538;
        KidCakePair[18].cake_yCord = 546;
        KidCakePair[18].kid_xCord = 129;
        KidCakePair[18].kid_yCord = 529;
        KidCakePair[18].blln_xCord = 288;
        KidCakePair[18].blln_yCord = 325;
        KidCakePair[18].kid_eye1 = {x:90,y:301};
        KidCakePair[18].kid_eye2 = {x:159,y:301};

        KidCakePair[9].cake_xCord = 508;
        KidCakePair[9].cake_yCord = 570;
        KidCakePair[9].kid_xCord = 195;
        KidCakePair[9].kid_yCord = 488;
        KidCakePair[9].blln_xCord = 290;
        KidCakePair[9].blln_yCord = 325;
        KidCakePair[9].kid_eye1 = {x:185,y:335};
        KidCakePair[9].kid_eye2 = {x:253,y:335};

        KidCakePair[19].cake_xCord = 508;
        KidCakePair[19].cake_yCord = 570;
        KidCakePair[19].kid_xCord = 195;
        KidCakePair[19].kid_yCord = 488;
        KidCakePair[19].blln_xCord = 290;
        KidCakePair[19].blln_yCord = 325;
        KidCakePair[19].kid_eye1 = {x:185,y:335};
        KidCakePair[19].kid_eye2 = {x:253,y:335};

        KidCakePair[0].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.billy_blueberry");
        KidCakePair[1].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.jake_jellybean");
        KidCakePair[2].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.charlie_chocolate");
        KidCakePair[3].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.sammy_swirl");
        KidCakePair[4].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.susie_sprinkles");
        KidCakePair[5].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.rainbow_reece");
        KidCakePair[6].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.lilly_lollipop");
        KidCakePair[7].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.shelly_sherbert");
        KidCakePair[8].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.izzy_icing");
        KidCakePair[9].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.rachel_raspberry");
        KidCakePair[10].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.duncan_doughnut");
        KidCakePair[11].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.petey_pastry");
        KidCakePair[12].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.mikey_mint");
        KidCakePair[13].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.kevin_candy_cane");
        KidCakePair[14].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.molly_macaron");
        KidCakePair[15].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.carole_bakings");
        KidCakePair[16].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.gloria_glaze");
        KidCakePair[17].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.sally_sugar");
        KidCakePair[18].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.karen_caramel");
        KidCakePair[19].kid_name = ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.names.gabby_gumdrop");

        KidCakePair[0].kid_soundName = "billy_blueberry";
        KidCakePair[1].kid_soundName = "jake_jellybean";
        KidCakePair[2].kid_soundName = "charlie_chocolate";
        KidCakePair[3].kid_soundName = "sammy_swirl";
        KidCakePair[4].kid_soundName = "susie_sprinkles";
        KidCakePair[5].kid_soundName = "rainbow_reese";
        KidCakePair[6].kid_soundName = "lilly_lollipop";
        KidCakePair[7].kid_soundName = "shelly_sherbert";
        KidCakePair[8].kid_soundName = "izzy_icing";
        KidCakePair[9].kid_soundName = "rachel_raspberry";
        KidCakePair[10].kid_soundName = "duncan_doughnut";
        KidCakePair[11].kid_soundName = "petey_pastry";
        KidCakePair[12].kid_soundName = "mikey_mint";
        KidCakePair[13].kid_soundName = "kevin_candycandy";
        KidCakePair[14].kid_soundName = "molly_macaron";
        KidCakePair[15].kid_soundName = "carole_bakings";
        KidCakePair[16].kid_soundName = "gloria_glaze";
        KidCakePair[17].kid_soundName = "sally_sugar";
        KidCakePair[18].kid_soundName = "karen_caramel";
        KidCakePair[19].kid_soundName = "gabby_gumdrop";

        KidCakePair[0].kid_ContainerOffSet = KidCakePair[10].kid_ContainerOffSet = 209.5;
        KidCakePair[1].kid_ContainerOffSet = KidCakePair[11].kid_ContainerOffSet = 250.5;
        KidCakePair[2].kid_ContainerOffSet = KidCakePair[12].kid_ContainerOffSet = 303;
        KidCakePair[3].kid_ContainerOffSet = KidCakePair[13].kid_ContainerOffSet = 238.5;
        KidCakePair[4].kid_ContainerOffSet = KidCakePair[14].kid_ContainerOffSet = 255;
        KidCakePair[5].kid_ContainerOffSet = KidCakePair[15].kid_ContainerOffSet = 272;
        KidCakePair[6].kid_ContainerOffSet = KidCakePair[16].kid_ContainerOffSet = 289;
        KidCakePair[7].kid_ContainerOffSet = KidCakePair[17].kid_ContainerOffSet = 275.5;
        KidCakePair[8].kid_ContainerOffSet = KidCakePair[18].kid_ContainerOffSet = 259.5;
        KidCakePair[9].kid_ContainerOffSet = KidCakePair[19].kid_ContainerOffSet = 310;      

        return {KidCakePair: KidCakePair, CandleLocation: CandleLocation};
    }

    static FinalScreenCakeLocations()
    {
        var FinalCakeLocation = [];
        FinalCakeLocation[0] = [651,702];
        FinalCakeLocation[1] = [527,680];
        FinalCakeLocation[2] = [847,694];
        FinalCakeLocation[3] = [408,695];
        FinalCakeLocation[4] = [174,722];

        FinalCakeLocation[5] = [949,547];
        FinalCakeLocation[6] = [744,587];
        FinalCakeLocation[7] = [515,558];
        FinalCakeLocation[8] = [324,558];
        FinalCakeLocation[9] = [94,563];

        FinalCakeLocation[0] = [116, 677];
        FinalCakeLocation[1] = [502,703];
        FinalCakeLocation[2] = [318,550];
        FinalCakeLocation[3] = [683,665];
        FinalCakeLocation[4] = [906,597];

        FinalCakeLocation[5] = [507,587];
        FinalCakeLocation[6] = [915,720];
        FinalCakeLocation[7] = [299,684];
        FinalCakeLocation[8] = [109,572];
        FinalCakeLocation[9] = [694,563];
        return (FinalCakeLocation)
    }

    static FinalScreenKidLocations()
    {
        var FinalKidLocation = [];
        FinalKidLocation[0] = [53, 435,"Balloon"];
        FinalKidLocation[1] = [159, 438,"Kid"];
        FinalKidLocation[2] = [274, 437,"Balloon"];
        FinalKidLocation[3] = [385, 454,"VictoryBalloon"];
        FinalKidLocation[4] = [483, 453,"Balloon"];
        FinalKidLocation[5] = [608, 446,"VictoryBalloon"];
        FinalKidLocation[6] = [675, 474,"BalloonNumberAndConfetti"];
        FinalKidLocation[7] = [774, 480,"Display"];
        FinalKidLocation[8] = [846, 442,"BalloonNumberAndConfetti"];
        FinalKidLocation[9] = [966, 452,"DisplayCompleteFire"];
        return(FinalKidLocation);
    }

    static DepthListSend()
    {
        var i=0;
        var DepthList = 
        {   Behind: 0,
            Background: 0, 
            Kid: 0,
            String: 0,
            Balloon: 0,
            VictoryBalloon: 0,
            BalloonNumberAndConfetti: 0,
            Display: 0, 
            DisplayFire: 0, 
            DisplayCompleteFire: 0,
            Table: 0,
            CandlesBehind: 0,
            FireBehind: 0,
            Cake: 0,
            Candles: 0,
            TweenFire: 0,
            FireInFront: 0,
            EndString: 0,
            Instructions: 0,
            PauseBackDrop: 0,
            Menu: 0,
            YesNoBtn: 0
        };

        for (let x in DepthList)
        {
            DepthList[x] = i;
            i++;
        }
        return (DepthList);
    }
}